<template>
    <commonbody>
        <div class="corporation-details-header" slot="swiper">
        </div>
        <div class="clearfix common-width-box" id="contact-box" :style="getCommonStyle.style">
            <div class="contact-wrap">
                <div class="contack">
                    <div class="common-subtitle-box" style="text-align: left;padding-bottom: 50px;">
                        我们在这里等您<i>We are waiting for you here</i>
                    </div>
                    <div class="row">
                        <div class="map col-7 col-lg-7 col-md-12">
                            <img src="../../public/images/image.png">
                        </div>
                        <div class="main col-5 col-lg-5 col-md-12">
                            <div class="common-subtitle-box" style="text-align: left;padding-bottom: 50px;font-size: 1.8em;">
                                苏州葡旅葡萄酒进出口贸易有限公司<i>VINE TRAILS FINE WINE SELECTIONS CO LTD</i>
                            </div>
                            <p>微信：<br><img src="../../public/images/qrcode/t1.jpg"></p>
                            <p>联系人：<br>Odelia 欧彩华</p>
                            <p>手机： <br>+86 18651108294</p>
                            <p>邮件： <br>odelia@vinetrails.cn</p>
                            <p>地址： <br>苏州园区通园路80号，56文创园D栋，葡旅葡萄酒空间。</p>
                        </div>
                    </div>

                    <div class="lang-box">
                        <h3>品鉴小技巧</h3>
                        <h4>葡萄酒的品尝</h4>
                        <p>视觉：在待好酒以后，品尝者应该手持杯脚以45度角、合适的距离下进行观察，理想环境是在良好的光线下，对着白色平面进行观察。酒的颜色能够映出酒的一些特质。</p>
                        <p>嗅觉：嗅觉的运用在品尝中非常重要，它对香气的捕捉分析比味觉还要多。在酒倒入杯中静止下来以后就可以进行初次闻香，然后是摇杯再次闻香(结合视觉)。这期间，感受葡萄酒的水果类、花香类、植物草本类、矿物类、香料类的各种香气。</p>
                        <p>味觉：为了证实视觉和嗅觉、也为了得到全面的感觉，我们还需要用舌头和口腔来体味葡萄酒。葡萄酒喝入口中后，舌头缓慢搅动，让葡萄酒液充分的与舌头、上颗、下颚、脸颊内侧以及舌的位置接触，葡萄酒经过舌头咀嚼后，吞下一、两小口，然后吸入一些空气到口中，使葡萄酒的芳香度更加强烈。(吸气时，口的形状类似发英文字母“，吸力和缓，不可过猛，以免哈到喉咙。)当葡萄酒在口腔内的各个味觉感应区发生作用，此时应专注地去体会并且记录葡萄酒的结构 (酒精、酸、单宁、酒体等) 以及真实的味道。</p>
                    </div>
                    
                </div>
                
            </div>
        </div>

    </commonbody>
</template>

<script>
// @ is an alias to /src
import commonbody from '@/components/commonbody.vue';
import { mapGetters } from 'vuex';

export default {
    name: "CorporationDetails",
    components: {
        commonbody,
    },
    data() {
        return {
        };
    },
    computed: {
        ...mapGetters(['getCommonStyle']),
    },
    created() {
        // this.paramsUrl();
    },
    methods: {
    },
    mounted() {
    }
};
</script>
<style lang="scss" scoped>
.corporation-details-header {
    height: 600px;
    width: 100%;
    position: relative;
    background: url('../../public/images/banner.png') center;
    background-size: contain;
}

.contact-wrap {
    width: 100%;
    // height: 1080px;
    
    // background: url(../../public/images/location.png) center top;
    // background-size: cover;

    .contack {
        // width: 80%;
        max-width: 1536px;
        height: 100%;
        margin: 0 auto;
        position: relative;
        opacity: 0;
        height: auto;
        display: block;
        overflow: hidden;
        margin-bottom: 100px;

        animation: fadeInUp 1s ease forwards;

        .map {
            // width: 60%;
            float: left;

            img {
                width: 100%;
            }
        }

        .lang-box{
            color: #470125;
            width: 100%;
            display: block;
            overflow: hidden;
            text-align: left;
            padding-top: 50px;

            h3{
                font-size: 1.8em;
                // line-height: 20px;
                color: #470125;
                margin: 0px auto;
                text-align: left;
                position: relative;
                padding-bottom: 20px;
                // font-family: serif;
            }

            h4{
                color: #470125;
                margin: 0px auto;
                text-align: left;
                position: relative;
                padding-bottom: 10px;
            }
        }

        .main {
            // width: 40%;
            // height: 480px;
            background: rgba($color: #fff, $alpha: 0.8);
            // position: absolute;
            // top: 25%;
            // right: 10%;
            padding: 0 30px;
            float: left;
            

            // -webkit-box-shadow: 0px 0px 26px 10px rgba(153,153,153,1);
            // -moz-box-shadow: 0px 0px 26px 10px rgba(153,153,153,1);
            // box-shadow: 0px 0px 26px 10px rgba(153,153,153,1);

            img {
                width: 140px;
                margin: 0 auto;
            }

            span {
                width: 100%;
                display: block;
                padding-bottom: 40px;
            }

            p {
                text-align: left;
                padding-bottom: 20px;
                padding-left: 40px;
                font-size: 1.1em;
                background: url(../../public/images/icon.png) left top no-repeat;
                background-size: 30px;
            }
        }
    }
}
</style>

<style>
@-webkit-keyframes fadeInUp {
    0% {
        opacity: 0;
        -webkit-transform: translate3d(0, 20%, 0);
        transform: translate3d(0, 20%, 0);
    }

    to {
        opacity: 1;
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }
}

@keyframes fadeInUp {
    0% {
        opacity: 0;
        -webkit-transform: translate3d(0, 20%, 0);
        transform: translate3d(0, 20%, 0);
    }

    to {
        opacity: 1;
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }
}
</style>